import React from 'react';
export function TopBar() {
  return <header className="topbar" data-id="element-170">
      <div data-id="element-171">
        <span className="wordmark" data-id="element-172">ARMONY</span>
        <span className="wordmark-sub" data-id="element-173">Por Dermaclinic</span>
      </div>
      <span className="topbar-meta" data-id="element-174">
        Bundle de preparación · Acceso inmediato · $17
      </span>
    </header>;
}